export enum TableColumnKey {
    distributorAgentId = 'distributorAgentId',
    orderId = 'orderId',
    orderSequence = 'orderSequence',
    programName = 'programName',
    cardProfileName = 'cardProfileName',
    status = 'status',
    pfhNumber = 'pfhNumber',
    embossedName = 'embossedName',
    cardNumber = 'cardNumber',
    panLast4 = 'panLast4',
    cardType = 'cardType',
    cardCreatedTime = 'cardCreatedTime',
    cardExpiryTime = 'cardExpiryTime',
    e6CardStatus = 'e6CardState',
    statusUpdateTime = 'statusUpdateTime',
    preCreatedCard = 'preCreatedCard',
    imported = 'imported',
    blocked = 'blocked',
    reissued = 'reissued',
    reissueOrderId = 'reissueOrderId',
    originalCardNumber = 'originalCardNumber',
    deactivatedOriginalCardOnActivation = 'deactivatedOriginalCardOnActivation',
    cardActivationTime = 'cardActivationTime',
    creationTime = 'creationTime',
    lastModifiedTime = 'lastModifiedTime',
}

export interface TableRow {
    id: number;
    [TableColumnKey.distributorAgentId]: string;
    [TableColumnKey.orderId]: string;
    [TableColumnKey.orderSequence]: string;
    [TableColumnKey.programName]: string;
    [TableColumnKey.cardProfileName]: string;
    [TableColumnKey.status]: string;
    [TableColumnKey.pfhNumber]: string;
    [TableColumnKey.embossedName]: string;
    [TableColumnKey.cardNumber]: string;
    [TableColumnKey.panLast4]: string;
    [TableColumnKey.cardType]: string;
    [TableColumnKey.cardCreatedTime]: string | undefined;
    [TableColumnKey.cardExpiryTime]: string | undefined;
    [TableColumnKey.e6CardStatus]: string | undefined;
    [TableColumnKey.statusUpdateTime]: string | undefined;
    [TableColumnKey.preCreatedCard]: string | undefined;
    [TableColumnKey.imported]: string;
    [TableColumnKey.blocked]: string;
    [TableColumnKey.reissued]: string;
    [TableColumnKey.reissueOrderId]: string;
    [TableColumnKey.originalCardNumber]: string;
    [TableColumnKey.deactivatedOriginalCardOnActivation]: string;
    [TableColumnKey.cardActivationTime]: string | undefined;
    [TableColumnKey.creationTime]: string | undefined;
    [TableColumnKey.lastModifiedTime]: string | undefined;

    rawData: any;
}